import { isEntraReturn } from './entra';

// Microsoft sends the sign-in response to the site root (the registered redirect URI). Move it to /login,
// response intact, so the login page can complete the sign-in. This must run before the router module is
// evaluated: the router reads the URL when it is created and would redirect "/" to /login, dropping the response.
// main.tsx imports this file first for that reason.
if (window.location.pathname === '/' && isEntraReturn()) {
  window.history.replaceState(null, '', `/login${window.location.search}${window.location.hash}`);
}
